const api = `${process.env.REACT_APP_API_URL || ''}`;

export function getMediaUrl(part?: string): string {
  return part ? `${api}${part.startsWith('/') ? '' : '/'}${part}` : '';
}
